module.exports = __webpack_public_path__ + "static/media/newLogo.9632c502.png";